import { bl_applet_template_message_line_RowClass, bl_applet_template_message_line_RowInterface } from "../../dbschema/bl_applet_template_message_line.model";
import { BaseContainerModel } from '../base-container.model';

export class AppletTemplateMessgeLineContainer extends BaseContainerModel {
    bl_applet_template_message_line: bl_applet_template_message_line_RowInterface = new bl_applet_template_message_line_RowClass();
}